/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  PicklistWithData
} from '../'

export const FilterProductsStatus = ({ title, value, onChange }) => (
  <div className="sidebar__item slds-p-top_medium slds-p-right_large slds-p-bottom_small slds-p-left_large">
    <div className="slds-grid slds-wrap">
      <div className="slds-col slds-size_1-of-1 sidebar__item__title">
        {title}
      </div>
      <div className="slds-col slds-size_3-of-4">
        <div className="sidebar__item__choice">
          <PicklistWithData
            id='productsStatus'
            forField='IdentityProductsStatus'
            default='All'
            symbol='chevrondown'
            value={value === ''
              ? 'all'
              : value
            }
            onChange={onChange}
            closeDropdownOnSelect={true}
            inline={true}
          />
        </div>
      </div>
    </div>
  </div>
)

FilterProductsStatus.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

FilterProductsStatus.defaultProps = {
  title: 'Products status'
}



// WEBPACK FOOTER //
// ./src/components/filter-products-status/index.js